var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 20 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 0C19.161 0 20 .84 20 1.875v11.25C20 14.16 19.16 15 18.125 15H6.875A1.875 1.875 0 0 1 5 13.125V1.875C5 .839 5.84 0 6.875 0h11.25zM6.875 16.25a3.129 3.129 0 0 1-3.125-3.125V5H1.875C.839 5 0 5.84 0 6.875v11.25C0 19.16.84 20 1.875 20h11.25C14.161 20 15 19.16 15 18.125V16.25H6.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.3b9f6827a3da386d8f8980100a3f3df2.svg";
export { ForwardRef as ReactComponent };